/*
 * Copyright (C) 2020 Reciprocity, Inc - All Rights Reserved
 * Unauthorized use, copying, distribution, displaying, or public performance
 * of this file, via any medium, is strictly prohibited. All information
 * contained herein is proprietary and confidential and may not be shared
 * with any third party without the express written consent of Reciprocity, Inc.
 */

import { capitalize } from 'lodash';
import { DropdownOption } from '@/pages/import/types';

export const SPECIAL_ATTRIBUTES = ['Delete'];
export const OBJECT_TYPE_TO_REMOVE = ['Questionnaire', 'Risk'];

export enum AswObjectTypes {
  JIRA = 'Jira Issue',
  SNOW = 'Ticketing Task',
  REQUEST = 'Request',
}

export const JIRA_OBJECT_TYPE = [
  {
    titleSingular: 'Jira Issue',
    titlePlural: 'Jira Issues',
  },
];
export const SNOW_OBJECT_TYPE = [
  {
    titleSingular: 'Ticketing Task',
    titlePlural: 'Ticketing Tasks',
  },
];

export const JIRA_ATTRIBUTES = [
  {
    name: 'Title',
    displayName: 'Title',
    isMapping: false,
    isCustomAttribute: false,
    mandatory: true,
  },
  {
    name: 'Description',
    displayName: 'Description',
    isMapping: false,
    isCustomAttribute: false,
    mandatory: false,
  },
  {
    name: 'mapped_controls',
    displayName: 'Mapped Controls',
    isMapping: true,
    isCustomAttribute: false,
    mandatory: false,
  },
];
export const SNOW_ATTRIBUTES = [
  {
    name: 'title',
    displayName: 'Title',
    isMapping: false,
    isCustomAttribute: false,
    mandatory: true,
  },
  {
    name: 'description',
    displayName: 'Description',
    isMapping: false,
    isCustomAttribute: false,
    mandatory: true,
  },
  {
    name: 'due_date',
    displayName: 'Due Date',
    isMapping: false,
    isCustomAttribute: false,
    mandatory: true,
  },
  {
    name: 'assigned_to',
    displayName: 'Assigned To',
    isMapping: false,
    isCustomAttribute: false,
    mandatory: false,
  },
  {
    name: 'assignment_group',
    displayName: 'Assignment Group',
    isMapping: false,
    isCustomAttribute: false,
    mandatory: false,
  },
  {
    name: 'mapped_controls',
    displayName: 'Mapped Controls',
    isMapping: true,
    isCustomAttribute: false,
    mandatory: false,
  },
];

export const attributeToDropdownOption = (attribute: any, disabled: boolean): DropdownOption => {
  return {
    id: attribute.name,
    label: attribute.mandatory ? attribute.displayName + '*' : attribute.displayName,
    displayName: attribute.displayName,
    mandatory: attribute.mandatory,
    isMapping: attribute.isMapping,
    isCustomAttribute: attribute.isCustomAttribute,
    $isDisabled: disabled,
  };
};

export const attributeToDropdownOptionFromName = (name: string, mandatory: boolean): DropdownOption => {
  return {
    id: name,
    label: mandatory ? capitalize(name) + '*' : capitalize(name),
    displayName: capitalize(name),
    mandatory: mandatory,
    isMapping: false,
    isCustomAttribute: false,
    $isDisabled: false,
  };
};

export const objectTypeToDropdownOption = (objectType: any, disabled: boolean): DropdownOption => {
  return {
    id: objectType.titleSingular,
    label: objectType.titlePlural,
    $isDisabled: disabled,
  };
};

export const createUnmapDropdownOption = (attribute: DropdownOption): DropdownOption => {
  return {
    id: 'un' + attribute.id,
    label: 'un' + attribute.label,
    displayName: 'un' + attribute.displayName,
    mandatory: attribute.mandatory,
    isMapping: true,
    isCustomAttribute: false,
    $isDisabled: false,
  };
};
